export const FAQ_ITEMS = [
  {
    question: "Czym jest Sprawdzona Broń?",
    answer:
      "Sprawdzona Broń (sprawdzonabron.pl) to pierwsza w Polsce wyszukiwarka i porównywarka cen broni i amunicjiz interaktywną mapą. Agregujemy oferty ze sklepów zbrojeniowych z całego kraju w jednym miejscu. Naszym celem jest ułatwienie strzelcom znalezienia poszukiwanego modelu broni w najlepszej cenie i najdogodniejszej lokalizacji.",
  },
  {
    question: "Czy Sprawdzona Broń jest sklepem internetowym?",
    answer:
      "Nie. Nie prowadzimy sprzedaży broni ani amunicji. Jesteśmy platformą informacyjną (agregatorem). Po znalezieniu interesującej oferty użytkownik musi skontaktować się bezpośrednio z wybranym sklepem stacjonarnym, aby dokonać zakupu.",
  },
  {
    question: "Czy korzystanie z serwisu jest płatne?",
    answer:
      "Nie. Korzystanie z wyszukiwarki, mapy oraz porównywarki cen jest całkowicie darmowe dla użytkowników poszukujących broni.",
  },
  {
    question: "Czy widoczna dostępność broni jest aktualna?",
    answer:
      "Staramy się, aby dane na stronie były jak najbardziej aktualne. Nasz system pobiera informacje ze stron partnerów raz dziennie (około 2 w nocy). Jednakże, stany magazynowe w sklepach stacjonarnych zmieniają się dynamicznie. Zawsze zalecamy telefoniczne potwierdzenie dostępności w konkretnym sklepie przed udaniem się na miejsce.",
  },
  {
    question: "Jakie sklepy mogą zostać dodane do serwisu?",
    answer:
      "Sklep musi spełniać wszystkie wymagania prawne oraz posiadać stronę internetową, na której prezentowane są modele broni, które będziemy mogli przyporządkować do dostępnych kategorii.",
  },
  {
    question: "Czy dodanie sklepu do serwisu jest płatne?",
    answer: 'Nie. Jeżeli chcesz dodać sklep, użyj przycisku "Dodaj sklep" w menu.',
  },
  {
    question: "Dlaczego ceny na stronie różnią się od cen w sklepie?",
    answer:
      "Prezentowane ceny pochodzą z ostatnich aktualizacji ofert sklepów. Sklepy mogą zmieniać ceny w dowolnym momencie, a opóźnienie w synchronizacji danych może sporadycznie wystąpić. Obowiązującą ceną jest zawsze ta podana przez sprzedawcę w sklepie.",
  },
  {
    question: "Jak działa mapa dostępności?",
    answer:
      "Nasza interaktywna mapa pozwala sprawdzić, w których miastach i sklepach znajduje się poszukiwany przez Ciebie model broni. To idealne narzędzie, jeśli szukasz konkretnego pistoletu lub karabinu i chcesz wiedzieć, jak daleko musisz pojechać, aby go kupić.",
  },
  {
    question: "Czy mogę zarezerwować broń przez waszą stronę?",
    answer:
      "Nie oferujemy funkcji rezerwacji bezpośrednio przez nasz serwis. Aby zarezerwować broń, należy skontaktować się bezpośrednio ze sklepem, w którym znaleziono ofertę (numer telefonu lub link do strony sklepu zazwyczaj znajduje się w szczegółach oferty).",
  },
  {
    question: "Czy do zakupu broni potrzebuję pozwolenia?",
    answer:
      "Tak. Sprawdzona Broń prezentuje oferty broni palnej, której zakup w Polsce jest koncesjonowany. Aby nabyć broń palną, musisz posiadać stosowne pozwolenie na broń oraz ważną promesę (zaświadczenie uprawniające do nabycia broni), a zakup musi odbyć się osobiście w sklepie stacjonarnym.",
  },
  {
    question: "Czy mogę kupić amunicję przez internet?",
    answer:
      "W Polsce sprzedaż amunicji na odległość jest zabroniona dla osób cywilnych. Możesz użyć naszej strony, aby znaleźć sklep, który ma daną amunicję na stanie, ale zakupu musisz dokonać osobiście, okazując legitymację posiadacza broni.",
  },
];
